import AppForm from '../app-components/Form/AppForm';

Vue.component('app-file-location-form', {
    mixins: [AppForm],
    data: function() {
        return {
            form: {
                file_path:  '' ,
                original_file_name:  '' ,
                extension:  '' ,
                file_name:  '' ,
                mime_type:  '' ,
                file_disk_type:  '' ,
                
            }
        }
    }

});